<template>
    <div class="popup" v-show="show">
        <div class="detail bg_white">
            <div class="title f18 bold500 txt_black87 tc">提现金额</div>

            <div class="content">
                <div class="item txt_black54 f14 bold500">
                    <div class="title bold600 content-center">
                        <span class="iconfont icon-bixuan f20"></span>
                        用户名：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" placeholder="请输入用户名" v-model="enc_bank_name"/>
                    </div>
                </div>
                <div class="item txt_black54 f14 bold500">
                    <div class="title bold600 content-center">
                        <span class="iconfont icon-bixuan f20"></span>
                        银行卡号：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="number" placeholder="请输入银行卡号" v-model="enc_bank_no"/>
                    </div>
                </div>
                <div class="item txt_black54 f14 bold500">
                    <div class="title bold600 content-center">
                        <span class="iconfont icon-bixuan f20"></span>
                        银行编号：
                    </div>
                    <div class="ipt">
                        <selection :options="bankCodes" @change="bankCodeChange"></selection>
                    </div>
                </div>
            </div>
            <div class="buttons">
                <div class="fl f14 txt_4673E3 bold400 cursor_pointer" @click="show=false">取消</div>
                <button class="fr f14 txt_white bold400 tc cursor_pointer bg_E91E63" @click="submitEvent">提现</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "",
        data() {
            return {
                show: false,
                withdrawAmount: '',
                bankCodes: [],
                bank_code: '',
                enc_bank_name: '',
                enc_bank_no: '',
                amount: '',
            }
        },
        methods: {
            init(amount) {
                this.show = true;
                this.amount = amount;
                this.getBankCode();
            },
            getBankCode() {
                this.$api.get('/manage/bank').then((data) => {
                    this.bankCodes = data.map(item => {
                        return {
                            text: item.bank_name,
                            code: item.bank_code
                        }
                    });
                }).catch((error) => {
                    this.$alert.error({content: '获取银行编号失败:' + error});
                });
            },
            bankCodeChange(data) {
                this.bank_code = data.code;
            },
            submitEvent() {
                if(!this.enc_bank_name || !this.enc_bank_no || !this.bank_code || !this.amount) {
                    this.$modal({content: '请填写完整数据'});
                    return;
                }
                this.$api.post('/manage/withdraw', {
                    enc_bank_name: this.enc_bank_name,
                    enc_bank_no: this.enc_bank_no,
                    bank_code: this.bank_code,
                    amount: this.amount,
                }).then(() => {
                    this.$alert.success({content: '提现申请成功'});
                    this.show = false;
                }).catch((error) => {
                    this.$alert.error({content: '提现申请失败:' + error});
                });
            }
        }
    }
</script>

<style scoped>
    .detail {
        width: 500px;
    }

    /*.popup .content {*/
    /*    height: 150px;*/
    /*    padding-top: 25px;*/
    /*}*/
</style>
